import Graph from "./Graph";
import NumView from "./NumView";

class ResultPoint {
  // ---------------------------------------------------------------------------------------------------------
  // --	ResultPoint
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    //グラフ
    this.graph = new Graph();

    //Tweetボタン
    $(".js-btn-tw").click((e) => {
      this.onTweet();
      return false;
    });

    //カテゴリーごとのスコア
    const holder = this;
    this.catScores = [];
    $(".js-cat-score").each(function (index) {
      const catScore = new NumView($(this));
      holder.catScores.push(catScore);
    });

    //トータルスコア
    this.totalScore = new NumView($(".js-total-score"));
  }

  /**
   * 準備
   */
  ready(models, callback) {
    //モデル保持
    this.models = models;

    //トータルスコア
    let total = 0;
    for (let i = 0; i < this.models.length; i++) {
      const model = this.models[i];
      total += model.score;
    }

    //スコア初期値
    this.scores = [0, 0, 0, 0, 0];

    //OGPの表示切り替え
    const $ogp = $(".pg-result__result-panel >img");
    let ogp_path = "";
    if (total == 100) {
      this.shareLABEL = "MASTER";
      this.shareURL = "master.html";
      ogp_path = "./assets/img/result/ogp_1_MASTER.png";
    } else if (total >= 90) {
      this.shareLABEL = "DIAMOND";
      this.shareURL = "diamond.html";
      ogp_path = "./assets/img/result/ogp_2_DIAMOND.png";
    } else if (total >= 80) {
      this.shareLABEL = "PLATINA";
      this.shareURL = "platina.html";
      ogp_path = "./assets/img/result/ogp_3_PLATINA.png";
    } else if (total >= 70) {
      this.shareLABEL = "GOLD";
      this.shareURL = "gold.html";
      ogp_path = "./assets/img/result/ogp_4_GOLD.png";
    } else if (total >= 50) {
      this.shareLABEL = "SILVER";
      this.shareURL = "silver.html";
      ogp_path = "./assets/img/result/ogp_5_SILVER.png";
    } else {
      this.shareLABEL = "BRONZE";
      this.shareURL = "bronze.html";
      ogp_path = "./assets/img/result/ogp_6_BRONZE.png";
    }
    $ogp.on("load", () => {
      callback();
    });
    $ogp.attr("src", ogp_path);

    //OGP画像の初期表示
    gsap.set($(".pg-result__result-panel"), {
      alpha: 0,
      scaleX: 0.8,
      scaleY: 0.8,
    });
  }

  /**
   * スタート
   */
  start() {
    this.countUp();
  }

  /**
   * カウントアップ
   */
  countUp() {
    //スコア加算
    let total = 0;
    let finishCount = 0;
    for (let i = 0; i < this.models.length; i++) {
      const model = this.models[i];
      this.scores[i] += 1;
      if (this.scores[i] >= model.score) {
        this.scores[i] = model.score;
        finishCount++;
      }

      //数字更新
      const catScore = this.catScores[i];
      catScore.update(this.scores[i]);

      //トータルスコア
      total += this.scores[i];
    }

    //トータルスコア加算
    this.totalScore.update(total);

    //グラフアップデート
    this.graph.update(this.scores);

    //連続
    if (finishCount < 5) {
      gsap.delayedCall(0.03, this.countUp.bind(this));
    } else {
      const $panel = $(".pg-result__result-panel");
      gsap.to($panel, 0.3, {
        alpha: 1,
        ease: "none",
        delay: 0.2,
      });
      gsap.to($panel, 0.6, {
        scaleX: 1,
        scaleY: 1,
        ease: "back.out(1.7)",
        delay: 0.2,
      });
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	ツイート
  // ---------------------------------------------------------------------------------------------------------

  onTweet() {
    const text =
      encodeURIComponent(
        "iFreeレバレッジNASDAQ100理解度チェックQUIZの結果は「" +
          this.shareLABEL +
          "」ランクでした。"
      ) +
      "%0Ahttps://www.daiwa-am.co.jp/special/quiz/ifreeleverage_nasdaq100/" +
      this.shareURL +
      "%0A%0A" +
      encodeURIComponent("#iFreeレバレッジNASDAQ100理解度チェックQUIZ");
    const path = "http://twitter.com/intent/tweet?text=" + text;
    window.open(
      path,
      "win_t",
      "menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=400, width=680"
    );
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default ResultPoint;
